<template>
  <div class="">
    <div class="flexbox m-b-md justify-center box-base-table-search" v-if="isSearchable">
      <div class="flex-grow sale-detail-search" style="margin-right: 0;">
        <div class="search-block search-block-date datepicker-start">
          <label class="m-r-sm m-b-none">日付From </label>
          <div>
            <date-picker
              v-model="start"
              :not-after="end"
              placeholder=""
              ref="datepickerStart"
              format="YYYY/MM/DD"
              :lang="lang"
              @focusin.native="closePopup($refs.datepickerEnd)"
            ></date-picker>
          </div>
        </div>
        <div class="search-block search-block-date datepicker-end">
          <label class="m-r-sm m-b-none">日付To </label>
          <div>
            <date-picker
              v-model="end"
              :not-before="start"
              placeholder=""
              ref="datepickerEnd"
              format="YYYY/MM/DD"
              :lang="lang"
              @focusin.native="closePopup($refs.datepickerStart)"
            ></date-picker>
          </div>
        </div>
        <div class="search-block search-block-detail">
          <label class="m-r-sm m-b-none">明細 </label>
          <input type="text" class="form-control m-r-sm" v-model.trim="detail" name="detail">
          <div class="box-detail-btn-search">
            <button class="btn btn-warning ver-middle w-120" @click="onHandleSearch">フィルター</button>
          </div>
        </div>
        <div class="box-btn-download-csv">
          <button class="btn btn-primary w-120" @click="confirmDownloadCsv()">ダウンロード</button>
        </div>
      </div>
    </div>
    <div class="table-wrapper" ref="table">
      <table class="table table-bordered common-table widthedTable" :class="tableClass">
        <thead>
          <tr class="align-middle">
            <th
              v-for="(column, index) in columns"
              :class="column.headerClass"
              :key="index"
              :style="{width: column.width}"
              v-html="column.title"
            />
          </tr>
        </thead>
        <tbody>
          <tr v-if="!initial && countTableData() === 0">
            <td :colspan="columns.length" class="bg-danger text-danger text-center"><h5 style="font-weight: 600">データが見つかりません。</h5></td>
          </tr>
          <tr v-for="(item, index) in pageData" :key="index" v-else>
            <td
              v-for="(column, colIndex) in columns"
              :key="index + '-' + colIndex"
              :class="column.cellClass"
              :style="{width: column.width}"
            >
              <template>
                <slot :name="column.name" :row-data="item" :handle-data="handleData" :data="defaultData" :original-data="originalData"></slot>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination
      :url="this.url"
      :extraUrl="this.extraUrl"
      :extraUrlMode="this.extraUrlMode"
      @onChangePage="onChangePage"
      @zIndex="$emit('zIndex', $event)"
      @originalData="getOriginalData"
      :keyword="this.keyword"
      :needExtraData="needExtraData"
      :maxRows="maxRows"
      :loadingTableMode="loadingTableMode"
      :clientMode="clientMode"
      :needLoading="needLoading"
      :method="method"
      ref="pagination"
    />
  </div>
</template>
<script>
import Pagination from '@/components/PaginationLoadMore'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
export default {
  components: {
    DatePicker,
    Pagination
  },
  data () {
    return {
      column: null,
      sort: null,
      pageData: [],
      defaultData: [],
      originalData: [],
      search: this.searchValue || null,
      keyword: this.searchValue || null,
      initial: true,
      start: null,
      end: null,
      detail: null,
      mall: null,
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      checkAll: false
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    columns: {
      type: Array
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    tableClass: {
      type: String,
      default: ''
    },
    searchValue: {
      type: String,
      default: ''
    },
    needExtraData: {
      type: Boolean,
      default: false
    },
    maxRows: {
      type: Number,
      default: 100
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    clientMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    needLoading: {
      type: Boolean,
      default: true
    },
    method: {
      type: String,
      default: 'get'
    }
  },
  methods: {
    closePopup (dom) {
      dom.closePopup()
    },
    getOriginalData (data) {
      this.originalData = [...data]
    },
    /*
     * Handle on page change
     *
     * @param {Array} data All Data for table from API
     * @param {Object} extraData Extra data get from API
     * @param {Boolean} needClear Nead clear previous data to store a new one
     *
     * @return void
     */
    onChangePage (data, extraData, needClear, keepSort, newData) {
      this.defaultData = [...data]
      this.pageData = newData && newData.length > 0 ? [
        ...this.pageData,
        ...newData
      ] : [...data]
      if (!keepSort) {
        this.column = null
        this.name = null
      }
      if (this.initial) {
        this.initial = false
      }
      if (this.needExtraData) {
        this.$emit('extraData', extraData)
      }
    },
    handleData (item, type, isCallApi = false) {
      this.$refs.pagination.handleData(item, type, isCallApi)
    },
    countTableData () {
      if (this.defaultData === null) {
        return 0
      }
      return this.defaultData.length
    },
    onHandleSearchWithEnter (e) {
      if (e.keyCode !== 13) return

      this.onHandleSearch()
    },
    /*
     * Handle onclick search button
     *
     * @return void
     */
    onHandleSearch () {
      this.keyword = {
        from: this.start ? moment(this.start).format('YYYY/MM/DD 00:00:00') : null,
        to: this.end ? moment(this.end).format('YYYY/MM/DD 23:59:59') : null,
        detail: this.detail
      }
      this.$emit('keyword', this.keyword)
    },
    /*
     * Handle onclick reload button
     *
     * @param {Boolean} showLoading Need show loading for table
     * @param {Boolean} keepKeyword Is remove current keyword or not
     *
     * @return void
     */
    reload (showLoading = false, keepKeyword = false, needAll = false, forceClient = false) {
      if (keepKeyword) {
        this.$refs.pagination.reload(false, needAll, forceClient)
      } else {
        this.search = null
        const oldKeyword = this.keyword
        this.keyword = forceClient ? '' : null
        if (oldKeyword === null) {
          this.$refs.pagination.reload(showLoading, needAll, forceClient)
        }
      }
    },
    confirmDownloadCsv () {
      this.$emit('confirmDownloadCsv')
    }
  },
  mounted () {
    $('.datepicker-start .mx-input-append').click((evt) => {
      $('.datepicker-start .mx-input').focus()
    })
    $('.datepicker-end .mx-input-append').click((evt) => {
      $('.datepicker-end .mx-input').focus()
    })
  },
  watch: {
    defaultData () {
      if (!this.keyword) {
        this.$emit('countData', this.countTableData())
      }
    },
    search () {
      if (this.isSearchable) {
        this.$emit('onChangeSearch', this.search)
      }
    },
    searchValue () {
      this.keyword = this.searchValue
    }
  }
}
</script>

<style scoped>
@media (min-width: 1201px) {
  .search-block-detail input {
    width: 70%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/deliveryRequests/ExpanseDetailTable.vue